import { Layout, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { getMenuSider, items as defaultItems } from "../config/menu/configMenu";
import { useEffect, useState, useMemo } from "react";
import { useAuth } from "../utils/Auth/AuthWrapper";
import { useRecoilState } from "recoil";
import { languageState, themeState } from "../utils/atoms";
import "../layout/index.less";

type Props = {
  collapsed: boolean;
  setCollapsed: any;
  isTokenExpired: boolean;
};

const { Header } = Layout;

const SiderLayout = ({ collapsed, setCollapsed, isTokenExpired }: Props) => {
  const auth = useAuth();
  const { Sider } = Layout;
  const [menuItems, setMenuItems] = useState<any[]>(defaultItems);
  const location = useLocation();
  const navigate = useNavigate();
  const [language, setLanguage] = useRecoilState(languageState);
  const [themeMode, setThemeMode] = useRecoilState(themeState);

  const navigatePath = (data: any) => {
    navigate(data.keyPath[0]);
    window.scrollTo(0, 0);
  };

  const getMenu = async () => {
    try {
      const res = await getMenuSider();
      setMenuItems(res);
    } catch (error) {
      console.error("Error fetching menu:", error);
      // กำหนดค่า default ในกรณีที่การดึงข้อมูลล้มเหลว
      setMenuItems(defaultItems);
    }
  };

  useEffect(() => {
    const storedTheme = localStorage.getItem("themeMode") || "light";
    setThemeMode(storedTheme);

    const checkTokenAndFetchMenu = async () => {
      if (!isTokenExpired) {
        // ถ้า token ไม่หมดอายุ ให้ดึงเมนูทั้งหมด
        await getMenu();
      } else {
        // ถ้า token หมดอายุ ให้แสดงเฉพาะเมนูที่เข้าถึงได้สำหรับ User
        setMenuItems(
          defaultItems.filter((item) => item?.access.includes("User"))
        );

        // [OLD CODE] เดิม set hardcoded token (guest) ลง localStorage โดยตรง — เป็น code smell เพราะมี JWT จริงอยู่ในโค้ด
        // let user = {
        //   accessToken:
        //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjpudWxsLCJyb2xlX2lkIjoiYTQyZjVjOTktMjkxYS0xMWVmLThjMzYtMDI0MmFjMTUwMDA2Iiwib3JnX2lkIjoiZTgyZmI3ZjMtM2ZhMC00NDZkLThlZjQtOTc0MzQyMWI0Y2E4IiwiaWF0IjoxNzE4NzY2NzIzLCJleHAiOjE4MTkwMjU5MjN9.3Ba7mKxxjsBcp_aOmaP7P16E25_gZLSNwtjNkWATWNY",
        //   user_status: 1,
        //   user_id: null,
        //   user_name: null,
        //   profile_img: null,
        //   org_id: "e82fb7f3-3fa0-446d-8ef4-9743421b4ca8",
        //   org_name: "Ai9",
        //   role: "User",
        //   token:
        //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjpudWxsLCJyb2xlX2lkIjoiYTQyZjVjOTktMjkxYS0xMWVmLThjMzYtMDI0MmFjMTUwMDA2Iiwib3JnX2lkIjoiZTgyZmI3ZjMtM2ZhMC00NDZkLThlZjQtOTc0MzQyMWI0Y2E4IiwiaWF0IjoxNzE4NzY2NzIzLCJleHAiOjE4MTkwMjU5MjN9.3Ba7mKxxjsBcp_aOmaP7P16E25_gZLSNwtjNkWATWNY",
        //   expiresIn: null,
        // };
        // localStorage.setItem("stt", JSON.stringify(user));

        // [OLD CODE] เดิม set expire flag ลง localStorage
        // let expire = {
        //   expire_date: "expire",
        // };
        // localStorage.setItem("expire", JSON.stringify(expire));

        await getMenu();
      }
    };

    checkTokenAndFetchMenu();
    return;
  }, [isTokenExpired, setThemeMode]);

  const [isDrawerVisible, setDrawerVisible] = useState(false);

  const toggleDrawer = () => {
    setDrawerVisible(!isDrawerVisible);
  };

  const menu = useMemo(() => {
    const menuItems = getMenuSider();
    return menuItems;
  }, [menuItems, language]);

  return (
    // <Sider
    //   theme="light"
    //   style={{ fontSize: "16px", position: "fixed", top: "64px", left: "0", zIndex: "1000", height: "calc(100% - 64px)", width: "100%" }}
    //   collapsible
    //   collapsed={collapsed}
    //   onCollapse={(value) => setCollapsed(value)}
    // >
    //   <Menu
    //     defaultSelectedKeys={[location.pathname]}
    //     mode="inline"
    //     theme="light"
    //     style={{ fontSize: "16px" }}
    //     // items={menuItems}
    //     items={menu}
    //     onClick={navigatePath}
    //   />
    // </Sider>

    // <Header
    //   style={{
    //     display: "flex",
    //     alignItems: "center",
    //     justifyContent: "center",
    //     marginTop: "70px",
    //     background: themeMode === "light" ? "#F3F3F1" : "#141414",
    //     position: "fixed",
    //     top: "0",
    //     zIndex: "1000",
    //     width: "100%",
    //     borderBottom: "1px solid #e6e6e6",
    //     // padding:"0px"
    //   }}
    // >
    //   <Menu
    //     theme="light"
    //     mode="horizontal"
    //     defaultSelectedKeys={[location.pathname]}
    //     style={{
    //       flex: "none",
    //       minWidth: 0,
    //       background: themeMode === "light" ? "#F3F3F1" : "#141414",
    //       display: "flex",
    //       justifyContent: "center",
    //       width: "150%",
    //       paddingInline: "13px",
    //     }}
    //     items={menu}
    //     onClick={navigatePath}
    //   />
    // </Header>

    <Header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "70px",
        background: themeMode === "light" ? "#F3F3F1" : "#141414",
        position: "fixed",
        top: "0.5px",
        zIndex: "1000",
        width: "100%",
        // borderBottom: "2px solid #e6e6e6",
      }}
    >
      <div className="side-nav">
        <Menu
          className="menu-side"
          theme="light"
          mode="horizontal"
          defaultSelectedKeys={[location.pathname]}
          style={{
            flex: "none",
            minWidth: 0,
            background: themeMode === "light" ? "#F3F3F1" : "#141414",
            display: "inline-flex",
            justifyContent: "center",
            // width: "150%",
            width: "max-content",
            paddingInline: "13px",
            direction: "ltr",
            borderBottom: "none",
          }}
          items={menu}
          onClick={navigatePath}
        />
      </div>
    </Header>
  );
};

export default SiderLayout;
